var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from 'redux-saga/effects';
import { ADD_ADDRESS_REQUEST, addAddressFailure, addAddressSuccess } from '../../actions';
import API from '../../../utils/API';
const onAddAddress = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            API.post(`onbd/address?mode=${action.payload.mode}`, action.payload.request)
                .then(data => {
                resolve(data);
            })
                .catch(error => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* addAddressWorker(action) {
    try {
        const data = yield call(onAddAddress, action);
        yield put(addAddressSuccess(data));
    }
    catch (error) {
        yield put(addAddressFailure(error));
    }
}
export function* watchAddAddressData() {
    yield takeLatest(ADD_ADDRESS_REQUEST, addAddressWorker);
}
